import { render, staticRenderFns } from "./UserProfileCardForm.vue?vue&type=template&id=2c88118b"
import script from "./UserProfileCardForm.vue?vue&type=script&lang=js"
export * from "./UserProfileCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports